module.exports = __webpack_public_path__ + "assets/be94a88090601b022943ed2e83d73528.mp4";